/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournaments_Tab_PastInputs */



/**
* | output |
* | --- |
* | "Past" |
*
* @param {Tournaments_Tab_PastInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournaments_tab_past = /** @type {((inputs?: Tournaments_Tab_PastInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournaments_Tab_PastInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Passés")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pasados")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Passados")
	if (locale === "it") return /** @type {LocalizedString} */ ("Passati")
	return /** @type {LocalizedString} */ ("Past")
});